<template>
  <PageHeader
    :title="article.title"
    :uptitle="article.uptitle"
    :subtitle="article.subtitle"
    hero-class="bg-event"
    :breadcrumb="[{ name:'Tallózó', url:'/tallozo'},article.title]"
  >
    <ReOverlayLoader :loading="loading">
      <div
        v-if="isAdmin() "
        class="float-right mt-[-45px] flex" 
      >
        <nuxt-link
          v-if="isAdmin()"
          :to="'/admin/tallozo/cikk/' + article.id"
          class="action-icon icon-yellow mr-4"
        >
          <i class="fas fa-cog pr-0" />
        </nuxt-link>
      </div>
      <section>
        <div class="w-full bg-white">
          <div 
            class="article p-[15px] lg:p-[30px]"
            v-html="article.content[0].content"
          />
        </div>
        <div class="footnote-box">
          <p>text</p>
        </div>
        <div class="flex flex-col lg:flex-row gap-x-6">
          <div
            v-if="article.links && article.links.length >0"
            class="w-full bg-white pb-[20px] mt-[20px]"
          >
            <div class="bg-yellow text-center w-full text-white py-[10px] text-2xl ">
              <h4>Kapcsolódó oldalak</h4>
            </div>
            <div class="p-[40px]">
              <p
                v-for="(link, index) in article.links"
                :key="index"
                class="mb-3"
              >
                <a
                  :href="
                    link.url.includes('http') ? link.url : 'http://' + link.url
                  "
                  target="_blank"
                  class="link-red "
                >{{ link.name }}</a>
              </p>
            </div>
          </div>
          <div
            class="w-full bg-white pb-[20px] mt-[20px]"
            :class="{'lg:w-1/2' : !(article.links && article.links.length >0) } "
          >
            <div class="bg-yellow text-center w-full text-white py-[10px] text-2xl ">
              <h4>Forrás</h4>
            </div>
            <div class="p-[40px]">
              <a
                v-if="article.source.source"
                :href="article.source.source"
                target="_blank"
                class="link-red "
              >
                {{ article.source.name }}
                <span class="block">{{
                  article.published_at
                    ? dtformat(
                      article.published_at,
                      "YYYY-MM-DD",
                      "YYYY. MMMM D."
                    )
                    : dtformat(
                      article.created_at,
                      "YYYY-MM-DD",
                      "YYYY. MMMM D."
                    )
                }}
                </span>
              </a>
              <span
                v-else
              >{{ article.source.name }}<br><em>{{
                article.published_at
                  ? dtformat(
                    article.published_at,
                    "YYYY-MM-DD",
                    "YYYY. MMMM D."
                  )
                  : dtformat(
                    article.created_at,
                    "YYYY-MM-DD",
                    "YYYY. MMMM D."
                  )
              }}</em></span>
              <div
                v-if="getMainImgObj(article)"
                class="max-w-[200px]"
              >
                <a
                  :href="article.source.source ? article.source.source : '#'"
                  target="_blank"
                >
                  <RePictureSet
                    :image="getMainImgObj(article)"
                    image-class="img-fluid lazyload w-auto"
                    sizes="180px"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full flex flex-wrap place-content-center my-[20px] lg:my-[40px]">
          <facebook
            :url="metaUrl()"
            title="Facebook megosztás"
            button-class="mx-[8px]"
          />
          <twitter
            :url="metaUrl()"
            title="Twitter megosztás"
            button-class="mx-[8px]"
          />
          <email
            :url="metaUrl()"
            :subject="article.title + ' | Tallózó | Folkrádió'"
            :text="article.title + '%0D' + metaDescription()"
            title="Email küldés"
            button-class="mx-[8px]"
          />
        </div>
        <ReModal
          :show-if="isModal"
          :has-buttons="false"
          :is-transparent="true"
          :half="true"
        >
          <template #default>
            <img
              class="absolute right-[22px] p-2 cursor-pointer bg-gray bg-opacity-80"
              src="/img/close_icon.svg"
              alt=""
              @click="closeModal"
            >

            <transition
              name="fade"
              mode="out-in"
            >
              <div
                v-for="(item, index2) in selectedImages"
                :key="index2"
                class=""
              >
                <img
                  :src="item"
                  class="img-fluid"
                >
                <div class="text-center text-white text-2xl">
                  <p>
                    {{ slideIndex }} / {{ selectedImages.length }}
                  </p>
                </div>
              </div>
            </transition>
            <a
              v-if="selectedImages.length > 1"
              class="top-[50%] mt-[-50px] lg:left-[-35px] absolute cursor-pointer p-[10px] text-white text-4xl"
              @click="plusSlides(-1)"
            >
              <img
          
                src="/img/left_icon.svg"
                alt=""
              >
        
            </a>
            <a
              v-if="selectedImages.length > 1"
              class="top-[50%] mt-[-50px] right-[22px] lg:right-[-35px] absolute cursor-pointer p-[10px] text-white text-4xl"
              @click="plusSlides(1)"
            >
              <img
          
                src="/img/right_icon.svg"
                alt=""
              >
            </a>
          </template>
        </ReModal>
      </section>
    </ReOverlayLoader>
  </PageHeader>
</template>
<script>
import PageHeader from "~/components/folkradio/PageHeader.vue";
import ReOverlayLoader from "~/components/rxt/recomponent/ReOverlayLoader.vue";
import ReModal from "~/components/rxt/recomponent/ReModal.vue";
const facebook = () => import("~/components/rxt/social/facebook.vue");
const twitter = () => import("~/components/rxt/social/twitter.vue");
const email = () => import("~/components/rxt/social/email.vue");
import RePictureSet from '~/components/rxt/recomponent/RePictureSet.vue'
export default {
  components: {
    PageHeader,
    ReOverlayLoader,
    ReModal,
    facebook,
    twitter,
    email,
    RePictureSet
  },
  head() {
    return {
      titleTemplate:
        (this.article.uptitle ? (this.article.uptitle +  " | ") : "") + this.article.title +
        (this.article.subtitle ? " | " + this.article.subtitle : "") +
        ( this.article.themes_list ? " | " + this.article.themes_list.map(i => i.type).join(', ') : '') +
        (this.article.source ? (" | " + this.article.source.name) : '') +
        " | Tallózó",
      meta: [
        {
          hid: "title",
          name: "title",
          content:
            (this.article.uptitle ? (this.article.uptitle +  " | ") : "") + this.article.title +
            (this.article.subtitle ? " | " + this.article.subtitle : "") +
            ( this.article.themes_list ? " | " + this.article.themes_list.map(i => i.type).join(', ') : '') +
            (this.article.source ? (" | " + this.article.source.name) : '') +
            " | Tallózó"
        },
        {
          hid: "description",
          name: "description",
          content: this.metaDescription()
        },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content:
            (this.article.uptitle ? (this.article.uptitle +  " | ") : "") + this.article.title +
            (this.article.subtitle ? " | " + this.article.subtitle : "") +
            ( this.article.themes_list ? " | " + this.article.themes_list.map(i => i.type).join(', ') : '') +
            (this.article.source ? (" | " + this.article.source.name) : '') +
            " | Tallózó"
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content:
            this.article.images.length && this.article.images[0].thumbnail
              ? this.entity.recordings[0].album.thumbnail.url
              : this.$getDomain() + "/img/meta_default.png"
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: this.metaDescription()
        },
        {
          hid: "og:url",
          name: "og:url",
          property: "og:url",
          content: this.metaUrl()
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          property: "og:site_name",
          content: "Folkrádió"
        }
      ]
    };
  },
  data() {
    return {
      isModal: false,
      selectedImages: [],
      slideIndex: 1,

      article: {},
      selectedContent: 0,
      loading:false
    };
  },
  watch: {
    selectedContent(newValue, oldValue) {
      this.$router.push({
        query: { number: this.article.content[this.selectedContent].number }
      });
    }
  },
  async asyncData(context) {
    try {
      const response = await context.app.$axios.get(
        "/gleaners/" + context.params.id
      );

      const article = response.data.data;

      let returnUrl = null;
      if (process.server) {
        returnUrl = "/";
      } else {
        returnUrl = context.app.router.history.current.fullPath;
      }
      return {
        returnUrl,
        article
      };
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return context.error({
          statusCode: 404,
          message: "Cikk nem található!"
        });
      } else {
        return context.error({
          statusCode: 500,
          message: "Szerver hiba, kérlek lépj kapcsolatba az üzemeltetőkkel!"
        });
      }
    }
  },
  beforeMount() {
    const queryObject = this.$router.history.current.query;

    if (queryObject.number) {
      this.selectedContent = this.article.content.findIndex(item => {
        return item.number === queryObject.number;
      });

      // this.$router.push(queryObject)
    }
  },
  mounted() {
    const footnote = document.getElementsByClassName("footnote");

    const mouseoverevent = event => {
      const href = event.target.getAttribute("href");

      const id = href.split("#")[1];
      const footnote = document.getElementById(id);

      const footnotebox = document.getElementsByClassName("footnote-box")[0];

      // If pageX/Y aren't available and clientX/Y are,
      // calculate pageX/Y - logic taken from jQuery.
      // (This is to support old IE)
      if (event.pageX == null && event.clientX != null) {
        const eventDoc =
          (event.target && event.target.ownerDocument) || document;
        const doc = eventDoc.documentElement;
        const body = eventDoc.body;

        event.pageX =
          event.clientX +
          ((doc && doc.scrollLeft) || (body && body.scrollLeft) || 0) -
          ((doc && doc.clientLeft) || (body && body.clientLeft) || 0);
        event.pageY =
          event.clientY +
          ((doc && doc.scrollTop) || (body && body.scrollTop) || 0) -
          ((doc && doc.clientTop) || (body && body.clientTop) || 0);
      }

      footnotebox.style.top = event.pageY + 10 + "px";
      footnotebox.style.left = event.pageX + 10 + "px";
      footnotebox.textContent = footnote.textContent;
      footnotebox.classList.add("show");
    };

    const mouseleaveevent = event => {
      const footnotebox = document.getElementsByClassName("footnote-box")[0];

      footnotebox.classList.remove("show");
    };

    Array.from(footnote).forEach(element => {
      element.addEventListener("mouseover", mouseoverevent);
      element.addEventListener("mouseleave", mouseleaveevent);
    });

    const images = document.getElementsByClassName("img-fluid");
    Array.from(images).forEach((element, index) => {
      if (element.classList.contains("blank")) {
        element.addEventListener("click", function() {
          window.open(element.getAttribute("src"), "_blank");
        });
      } else {
        this.selectedImages.push(element.getAttribute("src"));
        element.addEventListener("click", this.openModal.bind(this, index + 1));
      }
    });
  },
  methods: {
    metaDescription() {
      return this.article.description ? this.article.description : "";
    },
    metaUrl() {
      return (
        this.$getDomain() +
        "/tallozo/cikk/" +
        this.article.id +
        "/" +
        this.article.slug
      );
    },
    hasMainImg(article) {
      if (article.source && article.source.thumbnail) {
        return true;
      }
      return false;
    },
    getMainImgObj(article) {
      if (article.source && article.source.thumbnail) {
        return article.source.thumbnail;
      }
      return null;
    },
    getMainImg(article) {
      if (article.source && article.source.thumbnail) {
        return article.source.thumbnail.url;
      }
      return "/img/event-default_w240.jpg";
    },
    dtformat(date, from, to) {
      return this.$moment(date, from).format(to);
    },
    escapeKeyListener(evt) {
      if (evt.keyCode === 27) {
        this.isModal = false;
      }
    },
    // Open the Modal
    openModal(id) {
      this.isModal = true;
      this.slideIndex = id;
      document.addEventListener("keyup", this.escapeKeyListener);
    },

    // Close the Modal
    closeModal() {
      this.isModal = false;
      this.slideIndex = 1;
      document.removeEventListener("keyup", this.escapeKeyListener);
    },

    // Next/previous controls
    plusSlides(n) {
      if (this.slideIndex + n > this.selectedImages.length) {
        this.slideIndex = 1;
      } else if (this.slideIndex + n < 1) {
        this.slideIndex = this.selectedImages.length;
      } else {
        this.slideIndex += n;
      }
    }
  }
};
</script>
<style>

  .article h1,
  .article h2,
  .article h3,
  .article h4,
  .article h5,
  .article h6 {
    @apply bg-gray-light font-source-sans-pro font-semibold text-2xl lg:text-4xl px-8 py-2 mx-[-15px] lg:mx-[-30px] lining-nums;
  }

  .article p {
    @apply mb-2 mt-1;
  }

  .article .img-fluid {
    @apply cursor-pointer max-w-full h-auto;

  }

  .article .footnote {
    vertical-align: super;
    font-size: 12px;
    color: #971010;
  }

  .article .footnotes {
    border-top: 1px solid gray;
    padding: 25px;
    font-size: smaller;
  }
  .article .footnotes > div {
    padding-bottom: 5px;
  }
  .article .footnotes > div .footnote {
    vertical-align: super;
    font-size: 12px;
    color: #971010;
  }
  .article .footnotes > div a {
    font-size: 12px;
  }

  .article li {
    @apply list-disc mb-2 ml-8;
  }
</style>
<style lang="scss" scoped>
.footnote-box {
  border: 1px black solid;
  border-radius: 10px;
  position: absolute;
  left: 0;
  top: 300px;
  padding: 10px;
  background: url(/img/hero/folknaptar-event.jpg);
  display: none;
  max-width: 300px;
  font-size: 14px;

  &.show {
    display: block;
  }

  p {
    margin: 0;
  }
}

.modal {
  display: block;
  position: fixed;
  padding-top: 70px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(255, 255, 255, 0.85);
}
/* Modal Content */
.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  width: fit-content;
  max-width: 1100px;
  border: none;
  border-radius: 0;
}

/* The Close Button */
.close {
  color: #971111;
  position: absolute;
  top: 0px;
  right: 15px;
  font-size: 44px;
  font-weight: bold;
  z-index: 99;
  font-style: unset;
}

.close:hover,
.close:focus {
  color: #999;
  text-decoration: none;
  cursor: pointer;
}

.ih-80 {
  max-height: 80vh;
}

/* Next & previous buttons */
.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  padding: 10px;
  margin-top: -50px;
  color: #971111 !important;
  font-weight: bold;
  font-size: 30px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
  -webkit-user-select: none;
}

/* Position the "next button" to the right */
.prev {
  left: -37px;
}

.next {
  right: -37px;
  border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover,
.next:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

/* Number text (1/3 etc) */
.numbertext {
  color: black;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

/* Caption text */
.caption-container {
  background-color: white;
  padding: 2px 16px;
  color: black;
}

img.demo {
  opacity: 0.6;
}

.active,
.demo:hover {
  opacity: 1;
}

img.hover-shadow {
  transition: 0.3s;
  cursor: pointer;
}

.hover-shadow:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  cursor: pointer;
}
</style>
